export const ACCESS_TOKEN_KEY = 'at';
export const ACCESS_TOKEN_KEY_EXP = 'ate';
export const REFRESH_TOKEN_KEY = 'ar';
export const REFRESH_TOKEN_KEY_EXP = 'are';
export const ACCESS_USER_KEY = 'au';
export const REGISTRATION_DATA = 'registerData';
